import { ReactNode } from 'react';

interface SectionProps {
  id: string;
  backgroundImage?: string;
  backgroundVideo?: string;
  videoHeight?: string;
  children?: ReactNode;
  className?: string;
}

const Section = ({
  id,
  backgroundImage,
  backgroundVideo,
  videoHeight = 'h-screen',
  children,
  className,
}: SectionProps) => {
  return (
    <section
      id={id}
      className={`${backgroundImage ? 'bg-gray-100  bg-center' : ''} ${className}`}
      style={{ backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none' }}
    >
      {backgroundVideo && (
        <video autoPlay loop muted className={`${videoHeight} absolute w-screen object-cover`}>
          <source src={backgroundVideo} type="video/mp4" />
        </video>
      )}
      {children}
    </section>
  );
};

export default Section;
